import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-order-details-parent',
    templateUrl: './order-details-parent.component.html',
    styleUrls: ['./order-details-parent.component.scss'],
    standalone: false
})
export class OrderDetailsParentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
